<template>
  <el-dialog
    :before-close="closeDialog"
    :visible.sync="show"
    class="canal-radio-dialog"
    title="Canal de Radio"
  >
    <el-container direction="vertical">
      <el-row :gutter="20" type="flex" width="100%">
        <el-col :span="6">
          <WorkgroupCentralSelector v-model="wgCentral" />
        </el-col>
        <el-col :span="10">
          <el-switch
            v-model="isAll"
            active-text="Abrir cancal con todos"
            inactive-text="Solo con uno"
          />
        </el-col>
        <el-col :span="8">
          <el-input
            v-show="!isAll"
            v-model="taxiLicense"
            placeholder="Introduce nº licencia"
            size="mini"
          />
        </el-col>
      </el-row>
    </el-container>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">Cancelar</el-button>
      <el-button type="primary" @click="openCanal">Abri canal</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import WorkgroupCentralSelector from "@/components/common/forms/WorkgroupCentralSelector.vue";

export default {
  name: "CanalRadioDialog",

  components: {
    WorkgroupCentralSelector,
  },

  data() {
    return {
      wgCentral: null,
      isAll: true,
      taxiLicense: "",
    };
  },

  computed: {
    ...mapGetters("app", ["taxis", "defaultSelectedWorkgroupAndCentral"]),
    ...mapGetters("canalRadioDialog", ["show"]),
  },

  methods: {
    ...mapActions("clientTaxis", ["openCanalTaxis"]),

    async openCanal() {
      const payload = {
        params: {
          wgId: this.wgCentral[0].wgId,
          centralId: this.wgCentral[0].centralId || undefined,
          taxiId: this.taxiLicense && this.taxis.find((t) => t.license === this.taxiLicense).id,
        },
      };
      await this.openCanalTaxis(payload);
      this.closeDialog();
    },

    closeDialog() {
      this.wgCentral = this.defaultSelectedWorkgroupAndCentral;
      this.taxiLicense = "";
      this.isAll = true;
      this.$store.commit("canalRadioDialog/setShow", false);
    },
  },

  mounted() {
    this.wgCentral = this.defaultSelectedWorkgroupAndCentral;
  },
};
</script>

<style lang="scss">
.canal-radio-dialog {
  .el-row {
    width: 100%;
    .el-input {
      max-width: 200px;
    }
  }
}
</style>
